import { Component } from '@angular/core';

@Component({
    selector: 'wudo-spinner',
    templateUrl: './wudo-spinner.component.html',
    styleUrls: ['./wudo-spinner.component.scss'],
})
export class WudoSpinnerComponent {}
